module.exports = __webpack_public_path__ + "img/case3.101eab41.png";